import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import AttributeOptions from './AttributeOptions.js';
import CustomAlert from '../components/CustomAlert.js';
import SaveStepButton from './SaveStepButton.js';

class CompanyTypeForm extends Component {


    render() {
        const { handleSubmit, submitting, error } = this.props;


        const company_sector = [
            {id:0 , name:'Servicos'},
            {id:1 , name:'Turismo'},
            {id:2 , name:'Comercio'},
            {id:3 , name:'Vitivinícola'},
            {id:4 , name:'Agrícola'},
            {id:5 , name:'Pecuario'},
            {id:6 , name:'Industria'}
        ];
        const company_category = [
            {id:0 , name:'Micro Agro'},
            {id:1 , name:'Micro'},
            {id:2 , name:'Pequeña'},
            {id:3 , name:'Mediana Tramo 1'},
            {id:4 , name:'Mediana Tramo 2'}
        ];


        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_company_type" description="Company type"/>
                           <div className="show-desktop">
                            <SaveStepButton/>
                        </div>
                    </div>
                    <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveCompanyType)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="company_sector" defaultValue="Sector económico" label="Sector económico" attributeName='company_sector' attributeOptions={company_sector}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="company_category" defaultValue="Categoría de la empresa" label="Categoría de la empresa" attributeName='company_category' attributeOptions={company_category}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                            <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

CompanyTypeForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'company_sector', required: true},{name: 'company_category', required: true}])
CompanyTypeForm = TopScrolleable(CompanyTypeForm);

CompanyTypeForm = reduxForm({
    form: 'CompanyTypeForm', // a unique name for this form
    validate
})(CompanyTypeForm);

CompanyTypeForm = withAuthControl(CompanyTypeForm);

export default CompanyTypeForm;


/** WEBPACK FOOTER **
 ** ./src/components/CompanyTypeForm.js
 **/